import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react-lite";

import { CheckboxToggle } from 'react-rainbow-components';
import { useLocation } from 'react-router-dom';
import { useStore } from "../../app/stores/store";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import LoadingComponent from "../../app/layout/LoadingComponent";

import { Form, Formik } from "formik";
import Swal from "sweetalert2";

import { Button, Icon } from "semantic-ui-react";
import "./src/css/convenios.css";

import { calculoFechas } from "../../components/Portafolio/helpers/calculoFechas";
import AddModalCotizaciones from "./Handlers/ModalCotizacion"

import { MyTextAreatConv,  MyTextInputConv, MyTextInputConvD, } from '../../app/common/form/MyTextInput';
import { MyTextInputFechas } from "../../app/common/form/MyTextInput";

import { MySelectInputControlConvChange } from "../../app/common/form/MySelectInput";
import UploadFileModal from "./Handlers/uploadFilesModal";
import AproveConvFrm from './Handlers/AproveConv';

import ModalEstudiantesXconvenio from "./Handlers/ModalEstudiantesXconvenio";

interface convenio {
  id: number,
  monto: number,
  fecha: string,
  pagado: boolean,
  codigoInstitucional: string,
  descripcion: string,
  sgtEntidadIdEntidad: string,
  catEdicionesId: number,
  participantes: number,
  descuento: number,
  sgtDependencia: number,
  fechaInicio: string,
  fechaFinal: string,
  tipoConvenio: number,
  pagoExoneracion: any,
  files: [],
  solicitudId: number
}

let pcosto: any;
let participanteS: any;
let calcular: any = 0;

let descuentoP: any;
let descuentoD: any;
let descuentoCalc: any = 0;
let RCalculo: any;

let dBase: any;
let mAbase: any;
let montoCalc: any = 0;

let convFiles: any = [];
let estadoconv: any;
let convConvId: any;
let data: any;

let convCotiId: any,
  correlativo: any,
  dependencia: any,
  destinatario: any,
  saludo: any,
  descripcion: any,
  descripcioncc: any,
  notas: any,
  nombre: any,
  puesto: any,
  archivo: any,
  startedAt: any,
  endedAt: any,
  dependenciaIni: any,
  descripcionIni: any,
  destinatarioIni: any,
  catCursoNombre: any,
  catCursoModalidad: any,
  participantes: any,
  fechaInicio: any,
  fechaIniciocc: any,
  fechaFinall: any,
  fechaFinalcc: any,
  catCursoMonto: any,
  monto: any,
  fecha: any,
  ConvCodEntidadId: any,
  ConvCodDependencia: any,
  ConvNomCurso: any,
  solicitudIni: any,
  exoneracionop: any,
  soliFiles: any,
  cotizarbth: any,
  aprobarbtn: any,
  disabledstng: any,
  disabledbool: any,
  pagado: boolean,
  curso: string
  ;

let descuentoPrint: any;
let permisos: any[] = [];

const apiURL = process.env.REACT_APP_API_URL;
const fileconv = process.env.REACT_APP_FILEPATH_CON_URL;
const filesoli = process.env.REACT_APP_FILEPATH_SOL_URL;

export default observer(function DetalleConvenios() {

  const { userStore: { user, logout, isLoggedIn, roles }, SGPersonaStore: { SGPersonaByName, loadSGPersona }, modalStore } = useStore();
  const location = useLocation();
  
  const [switchState, setSwitchState] = useState<boolean>(false);
  const [hasInstitucion, setHasInstitucion] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState("");
  const [selectedOption, setSelectedOption] = useState(0);
  const [loading, setLoading] = useState(false);
  
  const [modalShowF, setModalShowF] = React.useState(false);
  const [modalShowA, setModalShowA] = React.useState(false);
  const [modalShowE, setModalShowE] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  var pathGUID = window.location.pathname.split("/")[5];
  const URLConv = apiURL + `/CATConvenios/${encodeURI(pathGUID)}`;

  function showExArea() {
    let formSection = document.getElementById("showExArea") as HTMLDivElement;
    formSection.classList.add("ver-seccion-form");
    calculo();
    calculoDescuento();
  }

  function showHidArea() {
    let formSection = document.getElementById("showExArea") as HTMLDivElement;
    formSection.classList.remove("ver-seccion-form");
    cotizarbth = "disabled";
  }


  const [calculos, setCalculos] = useState();
  function calculo() {
    pcosto = (document.getElementById("pcosto") as HTMLInputElement).value;
    participanteS = (document.getElementById("participante") as HTMLInputElement).value;
    let multiplicar = pcosto * participanteS;
    calcular = multiplicar;
    setCalculos(calcular);
  }

  const [descuentoB, setDescuento] = useState();
  function calculoDescuento() {
    descuentoP = (document.getElementById("descuento") as HTMLInputElement).value;
    let descuentoN = (descuentoP / 100) * calcular;
    descuentoCalc = descuentoN;
    setDescuento(descuentoCalc);
    setTimeout(montotCalculo, 250);
    setTimeout(calculoPr, 300)
  }

  const [PrParticipante, setPrParticipante] = useState();

  function calculoPr() {
    descripcioncc = (document.getElementById("descripcion") as HTMLInputElement).value;
    fechaIniciocc = data.convenio?.fechaInicio;
    fechaFinalcc = data.convenio?.fechaFinal;

    let calcularPr = pcosto - descuentoP;
    descuentoPrint = calcularPr
    setPrParticipante(descuentoPrint);
  }

  const [montot, setMontot] = useState();
  function montotCalculo() {
    mAbase = (document.getElementById("monto") as HTMLInputElement).value;
    dBase = (document.getElementById("dbase") as HTMLInputElement).value;
    let montoTotal = mAbase - dBase;
    montoCalc = montoTotal;
    setMontot(montoCalc);
  }

  let exoneracion = [
    { index: 1, text: "Institucion", key: 1, value: "0" },
    { index: 2, text: "Estudiante", Key: 2, value: "1" },
  ];

  const getDetallesConv = async () => {
    setLoading(true);
    const resp = await fetch(URLConv);
    data = await resp.json();
    
    const ConvCodEntidad = ((data || {}).convenio || {}).sgtEntidadIdEntidad;
    ConvCodDependencia = ((data || {}).convenio || {}).sgtDependencia;
    ConvNomCurso = ((data || {}).convenio || {}).catEdicionesId;
    estadoconv = ((data || {}).convenio || {}).estadoConvenio;
    pagado = ((data || {}).convenio || {}).pagado;

    const URLEnt = apiURL + `/SGTEntidades/${encodeURI(ConvCodEntidad)}`;
    const respEn = await fetch(URLEnt);
    const dataEn = await respEn.json();

    const URLDep = apiURL + `/SGTDependencias/${encodeURI(ConvCodDependencia)}`;
    const respDep = await fetch(URLDep);
    const dataDep = await respDep.json();

    const URLEdi = apiURL + `/CATEdicion/${encodeURI(ConvNomCurso)}`;
    const respEdi = await fetch(URLEdi);
    const dataEdi = await respEdi.json();

    const filecon = process.env.REACT_APP_API_URL + `/Storage/${data.convenio?.id}/CATConvenio`;
    const rc = await fetch(filecon);
    const datafc = await rc.json();
    convFiles = datafc;

    const filesol = process.env.REACT_APP_API_URL + `/Storage/${data.convenio?.solicitudId}/CATSolicitudConvenio`;
    const rs = await fetch(filesol);
    const datafs = await rs.json();
    soliFiles = datafs;

    convConvId = data.convenio?.id;
    fecha = data.convenio?.fecha;
    solicitudIni = data.convenio?.solicitudId;
    correlativo = data.convenio?.codigoInstitucional;
    convCotiId = data.cotizacion?.id;
    dependenciaIni = dataDep?.dependencia;
    descripcionIni = data.convenio?.descripcion;
    destinatarioIni = dataEn?.entidad;
    dependencia = data.cotizacion?.dependencia;
    descripcion = data.cotizacion?.descripcion;
    destinatario = data.cotizacion?.destinatario;
    saludo = data.cotizacion?.saludo;
    notas = data.cotizacion?.notas;
    nombre = data.cotizacion?.nombre;
    puesto = data.cotizacion?.puesto;
    archivo = data.cotizacion?.archivo;
    startedAt = data.cotizacion?.startedAt;
    endedAt = data.cotizacion?.endedAt;
    catCursoNombre = dataEdi?.catCursos?.nombre;
    catCursoModalidad = dataEdi.catCursos?.modalidad;
    participantes = data.convenio?.participantes;
    fechaInicio = data.convenio?.fechaInicio;
    fechaFinall = data.convenio?.fechaFinal;
    catCursoMonto = dataEdi?.listaCuotas[0]?.monto;
    monto = data.convenio?.monto;
    exoneracionop = data.convenio?.pagoExoneracion.toString();
    descuentoD = data.convenio?.descuento;
    ConvCodEntidadId = ConvCodEntidad;
    curso = data.convenio?.curso;

    setLoading(false);

    if (descuentoD == 0) {
      setSwitchState(false);
    } else {
      setSwitchState(true)
    }

    if (descuentoD == 100) {
      setSelectedOption(100)
    } else {
      setSelectedOption(0)
    }

  };
  
  RCalculo = calculos;
  useEffect(() => { getDetallesConv() }, []);

    useEffect(() => {
    const url = window.location.href.toLowerCase();
    const hasWordC = url.includes("institucion");
    setHasInstitucion(hasWordC);
  }, [location]);

  disabledstng = estadoconv == 4 || estadoconv == 5 ? "disabled" : hasInstitucion ? "disabled" : "";
  disabledbool = estadoconv == 4 || estadoconv == 5 ? true : hasInstitucion ? true : false;

  const initialValuesConv: convenio = {
    id: convConvId,
    monto: RCalculo ? RCalculo : monto,
    fecha: fecha,
    pagado: false,
    codigoInstitucional: correlativo,
    descripcion: descripcioncc ? descripcioncc : descripcionIni,
    sgtEntidadIdEntidad: ConvCodEntidadId,
    catEdicionesId: ConvNomCurso,
    participantes: participanteS ? participanteS : participantes,
    descuento: !switchState ? 0 : descuentoD ? descuentoD : PrParticipante,
    sgtDependencia: ConvCodDependencia,
    fechaInicio: fechaIniciocc ? fechaIniciocc : fechaInicio,
    fechaFinal: fechaFinalcc ? fechaFinalcc : fechaFinall,
    tipoConvenio: 0,
    pagoExoneracion: selectedOption === 100 ? "0" : exoneracionop,
    files: [],
    solicitudId: solicitudIni,
  };

  useEffect(() => {
    if (switchState) {
      showExArea();
    } else {
      showHidArea();
    }
  }, [switchState]);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSwitchState(event.target.checked);
  };

  const URLConPut = apiURL + `/CATConvenios`;
  const updateHandler = async (
    values = {},
    { setSubmitting }: { setSubmitting: any }
  ) => {
    try {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      };
      const response = await fetch(URLConPut, requestOptions);
      if (response.ok) {
        ExitMsj();
      } else {
        ExitMsjError();
      }
    } catch (e) {
      ExitMsjError();
    } finally {
      setSubmitting(false);
      ExitMsj();
    }
  };

  function ropm() {
    setModalShow(true);
  }

  function ExitMsj() {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Código actualizado correctamente",
      text: 'El código se ha actualizado satisfactoriamente.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  function ExitMsjError() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Error",
      text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  return (
    <>
      {loading ? (
        <LoadingComponent content="Cargando contenido del código institucional..." />
      ) : (
        
          <Container className="detalle_convenio-area">
            <Container className="convenio-head-area">
              <Row key={convConvId}>

                <Col xs={5} className="head-section" >
                  <div className="convenio-head-row">
                    <p>Entidad:</p>
                    <h3>{destinatarioIni}</h3>
                  </div>
                </Col>

                <Col xs={1} className="head-section">
                  <div className="convenio-head-row">
                    <p>Solicitud:</p>
                    <h3>{solicitudIni}</h3>
                  </div>
                </Col>

                <Col xs={2} className="head-section dates-sec">
                  <div className="convenio-head-row">
                    <p>Fecha:</p>
                    <h3>{calculoFechas(fecha)}</h3>
                  </div>
                </Col>

                <Col xs={4} className="head-section">
                  <div className="convenio-head-row convenio-detalle-fecha">
                    <p>Convenio:</p>
                    <h3>{correlativo}</h3>
                  </div>
                </Col>

              </Row>
            </Container>

            <Container className="convenio-form-area">

              <div className="form-header">


                {estadoconv === 4 ?

                  
                    <Row className="header-detail" key={convConvId}>
                      <Col>
                        <h2>{curso}</h2>
                      </Col>
                      <Col>
                        <Button
                          className="upload-files primary"
                          animated = "vertical"
                          onClick={() => setModalShowE(true)}
                        >
                          <Button.Content visible>
                            Ver estudiantes
                          </Button.Content >
                          <Button.Content hidden className="b-icon">
                            <Icon name="list layout" />
                          </Button.Content>
                        </Button>
                      </Col>
                    </Row>
                  

                  : <h2>Modificación del código institucional</h2>}

                <hr />
                <h3>
                  <>
                    Los valores de éste formulario, son tomados al momento de crear el código <br />
                    { estadoconv === 4 ? <span>Este código ya fue aprobado y no se puede modificar</span>
                        : estadoconv === 5 ? <span>Este código ya fue aprobado y aplicado al menos un pago, por lo que no puede modificarse.</span>
                          : hasInstitucion ? <span>No cuenta con permisos para modificar este código</span>
                            : null }
                  </>
                </h3>
              </div>

              <Formik
                enableReinitialize
                initialValues={initialValuesConv}
                onSubmit={updateHandler}
              >
                {({
                  handleSubmit,
                  isValid,
                  isSubmitting,
                  dirty,
                  handleChange,
                  handleBlur,
                }) => (
                  <>
                    <div className="hidden-values"></div>

                    <Form
                      className="ui form convenio-form"
                      onSubmit={handleSubmit}
                      autoComplete="off"
                    >

                      <Row key={convConvId}>

                        <Col className="selecciona-fecha">
                          <MyTextInputFechas
                            className={`${disabledstng}`}
                            label="Inicio del curso"
                            placeholder=""
                            id="fechaInicio"
                            name="fechaInicio"
                            readOnly={disabledbool}
                            defaultValue={calculoFechas(fechaInicio)}
                            onFocus={(e: any) => (e.currentTarget.type = "date")}
                            onBlur={(e: any) => (e.currentTarget.type = "date")}
                          />
                        </Col>

                        <Col className="selecciona-fecha">
                          <MyTextInputFechas
                            className={`${disabledstng}`}
                            readOnly={disabledbool}
                            label="Fin del curso"
                            placeholder=""
                            id="fechaFinal"
                            name="fechaFinal"
                            defaultValue={calculoFechas(fechaFinall)}
                            onFocus={estadoconv == 4 ? null : (e: any) => (e.currentTarget.type = "date")}
                            onBlur={estadoconv == 4 ? null : (e: any) => (e.currentTarget.type = "date")}
                          />
                        </Col>

                      </Row>

                      <Row className="row-modalidad create-conv-form">
                        <Col>
                          <MyTextInputConvD
                            className={`disabled`}
                            readOnly={true}
                            placeholder="Q.00"
                            label="Costo por participante"
                            name="pcosto"
                            id="pcosto"
                            value={catCursoMonto}
                            onChange={() => {
                              calculo();
                              calculoDescuento();
                            }}
                          />
                        </Col>

                        <Col>

                          <MyTextInputConv
                            className={`${disabledstng}`}
                            readOnly={disabledbool}
                            label="Cant. de participantes"
                            name="participantes"
                            id="participante"
                            defaultValue={participantes}
                            value={participanteS}
                            onChange={() => {
                              calculo();
                              calculoDescuento();
                            }}
                          />

                        </Col>

                        <Col>
                          <MyTextInputConvD
                            className={`disabled`}
                            readOnly={true}
                            label="Monto base"
                            name="monto"
                            id="monto"
                            defaultValue={monto}
                            value={calculos}
                          />
                        </Col>

                        <Col xs={2} className="sect3 switch-area">
                          <p>¿Exoneración?</p>
                          <CheckboxToggle
                            className="switch-form-conv"
                            value={switchState}
                            onChange={handleSwitchChange}
                          />

                        </Col>
                      </Row>

                      <Col className="exo-area" id="showExArea">
                        <Row key={convConvId}>

                          <Col className="select-p-descuento">
                            <label>Exoneración %</label>
                            <select
                              className={`${disabledstng}`}
                              disabled={disabledbool}
                              name="descuento"
                              id="descuento"
                              value={descuentoD}
                              onChange={(e: any) => {
                                descuentoD = e.target.value;
                                calculo();
                                calculoDescuento();
                                setSelectedOption(e.target.value);
                              }}
                            >
                              <option value={0} label=" - Selecciona -" >
                                Seleccione un porcentaje{" "}
                              </option>
                              <option
                              id="5"
                              value={5}
                              label="5%"
                              className="opcion-select"
                            >
                              5%{" "}
                            </option>

                            <option
                              id="10"
                              value={10}
                              label="10%"
                              className="opcion-select"
                            >
                              10%{" "}
                            </option>

                            <option
                              id="15"
                              value={15}
                              label="15%"
                              className="opcion-select"
                            >
                              15%{" "}
                            </option>

                            <option
                              id="20"
                              value={20}
                              label="20%"
                              className="opcion-select"
                            >
                              20%{" "}
                            </option>

                            <option
                              id="25"
                              value={25}
                              label="25%"
                              className="opcion-select"
                            >
                              25%{" "}
                            </option>

                            <option
                              id="50"
                              value={50}
                              label="50%"
                              className="opcion-select"
                            >
                              50%{" "}
                            </option>

                            <option
                              id="75"
                              value={75}
                              label="75%"
                              className="opcion-select"
                            >
                              75%{" "}
                            </option>
                            <option
                              id="90"
                              value={90}
                              label="90%"
                              className="opcion-select"
                            >
                              90%{" "}
                            </option>
                            <option
                              id="100"
                              value={100}
                              label="100%"
                              className="opcion-select"
                            >
                              100%{" "}
                            </option>
                            </select>
                          </Col>

                          <Col>
                            <MyTextInputConvD
                              // className={`${disabledstng}`}
                              // readOnly={disabledbool}
                              className={`disabled`}
                              readOnly={true}
                              label="Descuento base"
                              placeholder="Q. 000"
                              type="input"
                              id="dbase"
                              name="dbase"
                              value={descuentoB}
                            />
                          </Col>

                          <Col>
                            <MyTextInputConvD
                              // className={`${disabledstng}`}
                              // readOnly={disabledbool}
                              className={`disabled`}
                              readOnly={true}
                              label="Total"
                              placeholder="Q. 000"
                              type="input"
                              id="total"
                              name="total"
                              value={montot}
                            />
                          </Col>

                          {selectedOption.toString() !== "100" ?
                            <Col className="select-quien-paga">

                              <MySelectInputControlConvChange
                                className={`${disabledstng} quien-paga`}
                                readOnly={disabledbool}
                                label="Responsable del pago"
                                id="pagoExoneracion"
                                name="pagoExoneracion"
                                placeholder={"- Selecciona -"}
                                defaultvalue={exoneracionop}
                                options={exoneracion}
                              />

                            </Col>
                            :

                            null

                          }

                        </Row>
                      </Col>

                      <MyTextAreatConv
                        className={`${disabledstng}`}
                        readOnly={disabledbool}
                        label="Descripción del código"
                        placeholder=""
                        type="textarea"
                        id="descripcion"
                        name="descripcion"
                        defaultValue={descripcionIni}
                      />

                      <Row className="form-convenios-footer-btns justify-content-between">

                        { estadoconv === 4 || estadoconv === 5 ? 

                          null

                          : hasInstitucion ? null : (

                          <>

                            <Col sm={4} className="crear-conv-area-btn">

                              <Button
                                className="ui green button button-conv"
                                loading={loading}
                                type="submit"
                                animated
                              >
                                <Button.Content visible>
                                  Actualizar
                                </Button.Content>
                                <Button.Content hidden>
                                  <Icon name="handshake outline" />
                                </Button.Content>
                              </Button>

                            </Col>

                            <Col sm={4} className="crear-conv-area-btn">
                              { 
                                cotizarbth = switchState === true && selectedOption.toString() == "100" && selectedOption2 !== "1" ? 'disabled' 
                                  : cotizarbth = switchState === true && selectedOption.toString() == "75" && selectedOption2 !== "1" ? 'disabled' 
                                    : cotizarbth = switchState === true && selectedOption.toString() == "50" && selectedOption2 !== "1" ? 'disabled'
                                      : cotizarbth = switchState === true && selectedOption.toString() == "25" && selectedOption2 !== "1" ? 'disabled'
                                        : ''
                              
                              }
                              {/* {cotizarbth = switchState === true && selectedOption !== "100" && selectedOption2 !== "0" ? '' : 'disabled';} */}

                              <Button
                                className={`ui blue button button-conv ${cotizarbth}`}
                                type="button"
                                animated
                                onClick={ropm}
                              >
                                <Button.Content visible>
                                  Cotizar
                                </Button.Content>
                                <Button.Content hidden>
                                  <Icon name="handshake outline" />
                                </Button.Content>
                              </Button>

                            </Col>

                            <Col sm={4} className="crear-conv-area-btn">
                              {aprobarbtn = estadoconv == 1 || estadoconv == 2 || estadoconv == 3 ? null : `disabled`}

                              <Button
                                className={`ui orange button button-conv ${aprobarbtn}`}
                                type="button"
                                animated
                                onClick={() => setModalShowA(true)}
                              >
                                <Button.Content visible>Aprobar</Button.Content>
                                <Button.Content hidden>
                                  <Icon name="check" />
                                </Button.Content>
                              </Button>

                            </Col>

                          </>
                        )}

                      </Row>

                    </Form>
                  </>
                )}
              </Formik>

              <Container className="convenios-documentos-area">
                <div className="form-header">
                  <h2>Gestiones</h2>
                  <hr />
                  <h3 className="info-message-convenio">
                    A continuación encuentra los archivos o documentos que
                    respaldan los procesos del código.
                  </h3>
                </div>

                <Row>
                  <Container className="file-list-header">
                    <Col xs={2}>Fecha:</Col>
                    <Col xs={8}>Descripción:</Col>
                    <Col xs={2}>Acciones:</Col>
                  </Container>
                </Row>

                {soliFiles &&
                  soliFiles.map((docu: any) => (
                    <Container key={docu?.id} className="archivo-item">
                      <Col xs={2}>{calculoFechas(docu.createdAt)}</Col>
                      <Col xs={8}>{docu.descriptionFile}</Col>
                      <Col xs={2}>
                        <a
                          href={filesoli + "/" + docu?.fileName}
                          target="blank"
                        >
                          <Button.Group basic size="small">
                            <Button icon="download" />
                          </Button.Group>
                        </a>
                      </Col>
                    </Container>
                  ))
                }

                {convFiles &&
                  convFiles.map((docu: any) => (
                    <Container key={docu?.id} className="archivo-item">
                      <Col xs={2}>{calculoFechas(docu.createdAt)}</Col>
                      <Col xs={8}>{docu.descriptionFile}</Col>
                      <Col xs={2}>
                        <a
                          href={fileconv + "/" + docu?.fileName}
                          target="blank"
                        >
                          <Button.Group basic size="small">
                            <Button icon="download" />
                          </Button.Group>
                        </a>
                      </Col>

                    </Container>
                  ))
                }

                <hr />

                <Row className="upload-files-conv">
                  <Col>


                    {pagado == true ? null :

                      <Button
                        className="primary upload-files"
                        type="button"
                        animated = "vertical"
                        onClick={() => setModalShowF(true)}
                      >
                        <Button.Content visible>
                          Cargar archivos
                        </Button.Content>
                        <Button.Content hidden>
                          <Icon name="file pdf outline" />
                        </Button.Content>
                      </Button>

                    }

                  </Col>
                </Row>

              </Container>            
            </Container>
          </Container>

        
      )}

      <ModalEstudiantesXconvenio
    
        onHide={() => { setModalShowE(false) }}
        show={modalShowE}
        conv={convConvId}
        convref={correlativo}
      />

      <AproveConvFrm
       
        onHide={() => { setModalShowA(false) }}
        show={modalShowA}
        id={solicitudIni}
        idConvenio={convConvId}
        Files={null}
        correlativo={correlativo}
        cnombre={catCursoNombre}
      />

      <UploadFileModal
        onHide={() => { setModalShowF(false) }}
        show={modalShowF}
        solicitudID={convConvId}
        CType={"CATConvenio"}
        insti={null}
      />

      <AddModalCotizaciones
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        idCoti={convCotiId}
        idConv={convConvId}
        correlativo={correlativo}
        dependencia={dependencia}
        destinatario={destinatario}
        saludo={saludo}
        descripcion={descripcion}
        notas={notas}
        nombre={nombre}
        puesto={puesto}
        archivo={archivo}
        startedAt={startedAt}
        endedAt={endedAt}
        dependenciaIni={dependenciaIni}
        descripcionIni={descripcionIni}
        destinatarioIni={destinatarioIni}
        catCursoNombre={catCursoNombre}
        catCursoModalidad={catCursoModalidad}
        participantes={participanteS ? participanteS : participantes}
        fechaInicio={fechaInicio}
        fechaFinal={fechaFinall}
        catCursoMonto={PrParticipante ? PrParticipante : catCursoMonto}
        monto={montot ? montot : monto}
        descuento={montot ? montot : 0}
      />

    </>
  );
});